import { useEffect, useState } from "react";

import UsersList from "./UserList";
import { Dialog } from "primereact/dialog";

import { Card } from "primereact/card";
import UsersCreate from "./UserCreate";
import { IUser } from "./User.model";
import { userService } from "../../service/User/user.service";

const User = () => {
  const [userDialog, setUserDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IUser[]>([]);
  const openNew = () => {
    setUserDialog(true);
  };

  const hideDialog = () => {
    setUserDialog(false);
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    setLoading(true);
    const res = await userService.getAll();
    const sortedData = [...res.data].sort((a, b) => a.id - b.id);
    setData(sortedData);
    setLoading(false);
  };

  return (
    <>
      <Card>
        <Dialog
          visible={userDialog}
          header={"User Details"}
          modal
          onHide={() => hideDialog()}
          style={{ width: "50vw" }}>
          <UsersCreate setUserDialog={setUserDialog} loadUsers={loadUsers} />
        </Dialog>
        <UsersList
          openNew={openNew}
          loading={loading}
          data={data}
          loadUsers={loadUsers}
        />
      </Card>
    </>
  );
};

export default User;
